export const PATTERN_CLASSES = {
  'فعل + فاعل': 'verb',
  // 'فعل + حرف جر + فاعل': 'verb',
  'فعل + مفعول به': 'verb',
  'فعل + حرف جر + مفعول به': 'verb',
  'مضاف إليه + مضاف': 'noun',
  'اسم + حرف جر + اسم': 'noun',
  'اسم + صفة': 'adj',
  'صفة + اسم': 'adj'
}
export const SORTED_QUALIFIED_PATTERNS = {
  'NOUN': [
    { 'pattern': 'فعل + فاعل', 'core_indexes': [1], 'css_label': 'verb' },
    // { 'pattern': 'فعل + حرف جر + فاعل', 'core_indexes': [2], 'css_label': 'verb' },
    { 'pattern': 'فعل + مفعول به', 'core_indexes': [1], 'css_label': 'verb' },
    { 'pattern': 'فعل + حرف جر + مفعول به', 'core_indexes': [2], 'css_label': 'verb' },
    { 'pattern': 'مضاف إليه + مضاف', 'core_indexes': [0], 'css_label': 'noun' },
    { 'pattern': 'اسم + حرف جر + اسم', 'core_indexes': [0], 'css_label': 'noun' },
    { 'pattern': 'مضاف إليه + مضاف', 'core_indexes': [1], 'css_label': 'noun' },
    { 'pattern': 'اسم + حرف جر + اسم', 'core_indexes': [2], 'css_label': 'noun' },
    { 'pattern': 'اسم + صفة', 'core_indexes': [0], 'css_label': 'adj' },
    { 'pattern': 'صفة + اسم', 'core_indexes': [1], 'css_label': 'adj' }
  ],
  'VERB': [
    { 'pattern': 'فعل + فاعل', 'core_indexes': [0], 'css_label': 'verb' },
    // { 'pattern': 'فعل + حرف جر + فاعل', 'core_indexes': [0], 'css_label': 'verb' },
    { 'pattern': 'فعل + مفعول به', 'core_indexes': [0], 'css_label': 'verb' },
    { 'pattern': 'فعل + حرف جر + مفعول به', 'core_indexes': [0], 'css_label': 'verb' }
  ],
  'ADJ': [
    { 'pattern': 'اسم + صفة', 'core_indexes': [1], 'css_label': 'adj' },
    { 'pattern': 'صفة + اسم', 'core_indexes': [0], 'css_label': 'adj' }
  ]
}
